import { render, staticRenderFns } from "./ProductManufactureList.vue?vue&type=template&id=1d735cf3&scoped=true&"
import script from "./ProductManufactureList.vue?vue&type=script&lang=js&"
export * from "./ProductManufactureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d735cf3",
  null
  
)

export default component.exports